import Vue from 'vue'
import IdleVue from "idle-vue"
import store from './../store'

// Timeout Session
Vue.prototype.$timeoutSession = 120 //per minutes
const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: (1000 * 60) * Vue.prototype.$timeoutSession,
  startAtIdle: false
});